'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Empty;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Empty(props) {
  var emptyIcon = props.emptyIcon,
      emptyTitle = props.emptyTitle,
      emptyDescription = props.emptyDescription,
      columnsLength = props.columnsLength;
  return _react2["default"].createElement('tr', null, _react2["default"].createElement('td', {
    colSpan: columnsLength
  }, _react2["default"].createElement('div', {
    className: 'rainbow-table_body--empty-container'
  }, _react2["default"].createElement('span', {
    className: 'rainbow-table_body--empty-icon'
  }, emptyIcon), _react2["default"].createElement('h1', {
    className: 'rainbow-table_body--empty-title'
  }, emptyTitle), _react2["default"].createElement('h2', {
    className: 'rainbow-table_body--empty-description'
  }, emptyDescription))));
}

Empty.propTypes = {
  columnsLength: _propTypes2["default"].number,
  emptyIcon: _propTypes2["default"].node,
  emptyTitle: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].node]),
  emptyDescription: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].node])
};
Empty.defaultProps = {
  columnsLength: 0,
  emptyIcon: undefined,
  emptyTitle: undefined,
  emptyDescription: undefined
};